const CONTENT_BASE_URL = (
  process.env.REACT_APP_CONTENT_BASE_URL ||
  'https://57471c-455375.s3.ca-central-1.amazonaws.com/assets/stjohnstattooconvention.com'
).replace(/\/+$/, '');

function encodeAssetPath(path) {
  return String(path)
    .split('/')
    .map((part) => encodeURIComponent(part))
    .join('/');
}

export function imageAssetUrl(filename) {
  return `${CONTENT_BASE_URL}/images/${encodeAssetPath(filename)}`;
}

export function metadataAssetUrl(filename) {
  return `${CONTENT_BASE_URL}/metadata/${encodeAssetPath(filename)}`;
}
